/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video': {
    width: 17,
    height: 14,
    viewBox: '0 0 17 14',
    data: '<path pid="0" d="M14 0a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h11zm0 1H3a2 2 0 0 0-1.995 1.85L1 3v8a2 2 0 0 0 1.85 1.995L3 13h11a2 2 0 0 0 1.995-1.85L16 11V3a2 2 0 0 0-1.85-1.995L14 1zM6.887 4c.138 0 .274.032.397.094l4.225 2.113a.887.887 0 0 1 0 1.586L7.284 9.906A.887.887 0 0 1 6 9.113V4.887c0-.49.397-.887.887-.887zm-.137.75v4.5L11.25 7l-4.5-2.25z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/video.js